import { useQuery } from "@tanstack/react-query";
import { getAuthUser } from "@/app/actions/user/action";
import { UserStore } from "@/app/stores/UserStore";
import { PublicUser } from "@/app/types/PublicUser";
import { UTime } from "@/app/utils/UTime";

export function useFetchUser(enabled = true, onSuccess?: (user: PublicUser) => void) {
  const setUser = UserStore((state) => state.setUser);

  return useQuery({
    queryKey: ["auth-user"],
    queryFn: async () => {
      const user = await getAuthUser();

      if (user) {
        setUser(user);
        onSuccess?.(user);
      }

      return user;
    },
    enabled,
    staleTime: UTime.minuteMs(5),
  });
}
